const coursesData = [
  {
    "id": "1",
    "courseName": "Digital Banking and Payment Solution",
    "image": "../courses/PERSONAL_DEVELOPMENT.jpg",
    "courseStructure":"../pdf/personalDevelopment.pdf"
  },
  {
    "id": "2",
    "courseName": "DIGITAL MARKETING",
    "image": "../courses/digital-marketing.png",
  },
  {
    "id": "3",
    "courseName": "CORE JAVA WITH JAVA 8",
    "image": "../courses/java8.png",
     "courseStructure":"../pdf/coreJava.pdf"
  },
  {
    "id": "4",
    "courseName": "AI POWERED SCRUM MASTER",
    "image": "../courses/sm.png",
    "courseStructure":"../pdf/ScrumMaster.pdf"

  },
  {
    "id": "5",
    "courseName": "DATA SCIENCE",
    "image": "../courses/ds.png",
    "courseStructure":"../pdf/Comprehensive Data Science.pdf"
  },
  
  
  {
    "id": "6",
    "courseName": "AGILE",
    "image": "../courses/agile.png",
   
  },
  {
    "id": "7",
    "courseName": "AI POWERED BUSINESS ANALYST",
    "image": "../courses/Business_Analyst.jpg",
    // "courseStructure":"../pdf/BA.pdf"
  },
  {
    "id": "8",
    "courseName": "NISM, NCFM CERTIFICATION PREPRATION",
    "image": "",
    // "courseStructure":"../pdf/.pdf"
  },
  {
    "id": "9",
    "courseName": "CAPITAL MARKET FOR BEGGINERS",
    "image": "../courses/capital-market.jpg",
    // "courseStructure":"../pdf/.pdf"
  },
 

  {
    "id": "12",
    "courseName": "MANUAL TESTING",
    "image": "../courses/manual.png",
    "courseStructure":"../pdf/ManualTesting.pdf"

  },
 
  // {
  //   "id": "14",
  //   "courseName": "MOBILE AUTOMATION TESTING",
  //   "image": "../courses/mobile_automation.jpg",
  //   "courseStructure":"../pdf/mobileAutomation.pdf"
    
  // },
  {
    "id": "15",
    "courseName": "WEB AUTOMATION TESTING",
    "image": "../courses/web-automation.jpg", 
    "courseStructure":"../pdf/WebAutomation.pdf"
  },
  {
    "id": "16",
    "courseName": "API AUTOMATION",
    "image": "../courses/api-automation.png",
    "courseStructure":"../pdf/ApiAutomation.pdf"
  },
  {
    "id": "17",
    "courseName": "DATA ANALYST",
    "image": "../courses/Data-Analyst.png",
    "courseStructure":"../pdf/Data Analyst.pdf"

  },
  {
    "id": "18",
    "courseName": "PYTHON DEVELOPER",
    "image": "../courses/best-python-training.png",
    "courseStructure":"../pdf/Comprehensive Python.pdf"
  },
  
  {
    "id": "20",
    "courseName": "Neural network & Generative AI with Python",
    "image": "../courses/NEURAL.jpg",
    "courseStructure":"../pdf/Comprehensive Python.pdf"
  },
  {
    "id": "19",
    "courseName": "POWER BI",
    "image": "../courses/power-bi.jpg",
    "courseStructure":"../pdf/Comprehensive Power BI.pdf"
  }
];

export default coursesData;
